import { Link } from '@alfa-bank/site-link';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Breadcrumbs as Component } from '../breadcrumbs';
import { Icon } from '../icon';
import { getPaths } from '../utils/get-paths';
import type { IDepsDesktop, TBreadcrumbsComponent } from '../models';
import styles from '../styles/styles.css';

export const BreadcrumbsDesktop = createWidget<IDepsDesktop, TBreadcrumbsComponent>({
    styles,
    getPaths,
    Icon,
    Link,
    Text,
})(Component);
